import React, {useState} from 'react';
import ModalContainer from "../../common/modal_container";
import {with_comma} from "../../../util/comma";
import partner from "../../../_asset/media/partner.png"
import EventAdLayout from './request_ad';
import Btn from '../../layout/Btn';
import { SiteLogo2 } from '../../common/header';

export default function WithdrawalModal({popShow, setPopShow}: {popShow: boolean; setPopShow: Function}){
    return (
        <ModalContainer
            show={popShow}
            setShow={setPopShow}
            closeBtn
            className={'deposit-popup'}
            title={<><p>출금계좌</p><SiteLogo2 /></>}
        >
            <div className={'warning'}>
                <div>
                    <p><b>주의사항</b></p>
                    <p><b>입금자명과 출금자명이 다를경우 본인확인 요청</b>있을 수 있습니다.</p>
                </div>
                {/* <EventAdLayout /> */}
            </div>
            <Table/>
            <div className={"btn-area"}>
                <Btn className='red'>출금신청</Btn>
            </div>
            {/* <img src={partner} alt="partner"/> */}
        </ModalContainer>
    )
}

function Table(){
    const [amount, setAmount] = useState<number>(0)

    function addAmount(num: number){
        setAmount(amount + num)
    }
    return (
        <div className={"deposit-table"}>
            <table>
                <tbody>
                <tr>
                    <th>출금금액*</th>
                    <td>
                        <div className={"amount-td"}>
                            <div className={'amount'}>
                                <input type="text" className={"amount"} value={with_comma(amount)} readOnly={true}/>
                            </div>
                            <div className={"deposit-btn"}>
                                <span onClick={e=> addAmount(10000)}>10,000</span>
                                <span onClick={e=> addAmount(50000)}>50,000</span>
                                <span onClick={e=> addAmount(100000)}>100,000</span>
                                <span onClick={e=> addAmount(500000)}>500,000</span>
                                <span onClick={e=> setAmount(0)}>초기화</span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>출금은행*</th>
                    <td>
                        <div className={"amount-td"}>
                            <input type="text" name={"withdrawal-bank"} />
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>출금계좌*</th>
                    <td>
                        <div className={"amount-td"}>
                            <input type="text" name={"withdrawal-number"} />
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>출금비밀번호*</th>
                    <td>
                        <div className={"amount-td"}>
                            <input type="password" name={"withdrawal-password"} />
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}